import styled, { css } from 'styled-components';

import MediaQueryBreakpoints from '@rockalingua/ui/constants/MediaQueryBreakpoints';

type FeatureGridSize = 'default' | 'compact';

export const Container = styled.div<{ $size: FeatureGridSize }>`
  width: 100%;
  margin: 24px 0;
  display: flex;
  justify-content: space-between;
  gap: 72px;

  ${(props) =>
    props.$size == 'compact' &&
    css`
      margin: 8px 0 16px;
      gap: 24px;
    `}

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    flex-direction: column;
  }
`;

export const FeatureItem = styled.div<{ $size: FeatureGridSize }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 24px;

  ${(props) =>
    props.$size == 'compact' &&
    css`
      gap: 12px;
    `}
`;

export const IconContainer = styled.div<{
  $backgroundColor: string;
  $size: FeatureGridSize;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 170px;
  border-radius: 50%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};

  ${(props) =>
    props.$size == 'compact' &&
    css`
      width: 56px;
      height: 56px;
    `}
`;
